import React from "react";
import ResumeIcon from "../assets/img/icon/resume-icon1.png";
import "../assets/css/fontawesome.css";
import "../assets/css/slick.css";
import "../assets/css/lightgallery.min.css";
import "../assets/css/animate.css";
import "../assets/css/style.css";
import ResumeIcon2 from "../assets/img/icon/resume-icon2.png";

const Resume = () => {
  return (
    <>
      <section id="resume" class="st-dark-bg">
        <div class="st-height-b100 st-height-lg-b80"></div>
        <div class="container">
          <div class="st-section-heading st-style1">
            <h4 class="st-section-heading-title">RESUME</h4>
            <h2 class="st-section-heading-subtitle">RESUME</h2>
          </div>
          <div class="st-height-b25 st-height-lg-b25"></div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-lg-6">
              <div class="st-resume-wrap">
                <div class="st-resume-heading">
                  <img src={ResumeIcon} alt="resume-icon" />
                  <h2 class="st-resume-heading-title">Experience</h2>
                </div>

                <div class="st-height-b50 st-height-lg-b30"></div>

                <div class="st-resume-timeline-wrap">
                  <div class="st-resume-timeline">
                    <h3 class="st-resume-timeline-title">
                      Frontend Developer Internship
                    </h3>
                    <div class="st-resume-timeline-duration">
                      June 2023 - September 2023
                    </div>
                    <h4 class="st-resume-timeline-subtitle">
                      ALUSOFT TECHNOLOGIES
                    </h4>
                    <div class="st-resume-timeline-text">
                      <p>Ibadan, Oyo State, Nigeria.</p> <br />
                      <p>
                        Skills: HTML5 · Cascading Style Sheets (CSS) · Bootstrap
                        JavaScript
                      </p>
                    </div>
                  </div>
                  <div class="st-height-b50 st-height-lg-b30"></div>
                  <div class="st-resume-timeline">
                    <h3 class="st-resume-timeline-title">Backend Developer</h3>
                    <div class="st-resume-timeline-duration">
                      May 2024 - June 2024
                    </div>
                    <h4 class="st-resume-timeline-subtitle">
                      College Tech Startup
                    </h4>

                    <div class="st-resume-timeline-text">
                      <p>
                        Developed and implemented a secure e-voting system
                        server for electoral voting. Utilized advanced backend
                        technologies to ensure data integrity, scalability, and
                        user privacy.
                      </p>
                    </div>
                    <div class="st-resume-timeline-text">
                      <p>Ibadan, Oyo State, Nigeria.</p> <br />
                      <p>
                        Skills: Nodejs · Express-js · MonogDb · Postman · Vercel
                      </p>
                    </div>
                  </div>

                  <div class="st-height-b50 st-height-lg-b30"></div>
                  <div class="st-resume-timeline">
                    <h3 class="st-resume-timeline-title">
                      Junior Frontend Developer
                    </h3>
                    <div class="st-resume-timeline-duration">
                      MAY 2024 - PRESENT
                    </div>
                    <h4 class="st-resume-timeline-subtitle">
                      Dimatech Tech Company
                    </h4>
                    <div class="st-resume-timeline-text">
                      <p>
                        Worked collaboratively with team members and
                        collaborators on a project for a Computer-Based Testing
                        (CBT) solution service. Developed and optimized user
                        interfaces to enhance usability and performance,
                        ensuring cross-browser compatibility and responsiveness.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="col-lg-6">
              <div class="st-height-b0 st-height-lg-b50"></div>
              <div class="st-resume-wrap">
                <div class="st-resume-heading">
                  <img src={ResumeIcon2} alt="resume-icon" />
                  <h2 class="st-resume-heading-title">Education</h2>
                </div>
                <div class="st-height-b50 st-height-lg-b30"></div>

                <div class="st-resume-timeline-wrap">
                  <div class="st-resume-timeline">
                    <h3 class="st-resume-timeline-title">
                      Software Engineering
                    </h3>
                    <div class="st-resume-timeline-duration">
                      September 2022 - PRESENT(August 2024)
                    </div>
                    <h4 class="st-resume-timeline-subtitle">
                      SQI College of ICT
                    </h4>
                    <p class="st-resume-timeline-subtitle"></p>
                    <div class="st-resume-timeline-text">
                      <p>
                        Developed a comprehensive understanding of software
                        engineering principles and practices. Acquired hands-on
                        experience in building full-stack applications,
                        encompassing both frontend and backend development, to
                        create robust and scalable software solutions.
                      </p>
                    </div>
                  </div>

                  <div class="st-height-b50 st-height-lg-b30"></div>
                  <div class="st-resume-timeline">
                    <h3 class="st-resume-timeline-title">
                      Secondary School Education
                    </h3>
                    <div class="st-resume-timeline-duration">2016 - 2022</div>
                    {/* <h4 class="st-resume-timeline-subtitle">
                      University of ABC
                    </h4> */}
                    {/* <div class="st-resume-timeline-text">
                      <p>
                        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                        Nunc ligula nulla, tincidunt id faucibus sed, suscipit
                        feugiat turpis.
                      </p>
                    </div> */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="st-height-b100 st-height-lg-b80"></div>
      </section>
    </>
  );
};

export default Resume;
